import type { ZodObject, ZodRawShape } from 'zod';
import { ObjectIdSchema } from '../primitives';
import { created } from '.';

export function segregated<Shape extends ZodRawShape>(entity: ZodObject<Shape>) {
  return created(entity).extend({
    accountId: ObjectIdSchema,
  });
}